import script from "./ServiceCardSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceCardSkeleton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__